import React from 'react';
import { Status, DaytradeType, ExchangeRateType, Direction } from '../logic/graphql/types/types.d';
import { assets } from '../assets';
import { IntlShape } from 'react-intl';

export const stringifyStatus = (status: Status | undefined, intl: IntlShape): string => {
  if (!status) return '';
  return intl.formatMessage({ id: `order.status.${status}` });
};

export const stringifyDaytradeType = (type?: DaytradeType | null): string => {
  if (!type) return '';

  switch (type) {
    case DaytradeType.Close:
      return 'Zárás';
    case DaytradeType.Open:
      return 'Nyitás';
  }
};

export const stringifyExchangeRateType = (
  type: ExchangeRateType | undefined,
  intl: IntlShape,
): string => {
  if (!type) return '';
  return intl.formatMessage({ id: `order.exchangeRateType.${type}` });
};

export const StatusIcon = (props: { status?: Status }): JSX.Element | null => {
  if (!props.status) return null;
  let icon: string;

  switch (props.status) {
    case Status.Active:
      icon = assets.icons.status_active;
      break;
    case Status.CancelRequested:
      icon = assets.icons.status_canceled;
      break;
    case Status.Canceled:
      icon = assets.icons.status_canceled;
      break;
    case Status.Completed:
      icon = assets.icons.status_completed;
      break;
    case Status.Expired:
      icon = assets.icons.status_expired;
      break;
    case Status.Partial:
      icon = assets.icons.status_partial;
      break;
    case Status.Pending:
      icon = assets.icons.status_pending;
      break;
    case Status.Rejected:
      icon = assets.icons.status_rejected;
      break;
  }

  return <img src={icon} />;
};

export const statusColor = (status?: Status): string => {
  if (!status) return '';
  switch (status) {
    case Status.Active:
      return 'var(--primary-color)';
    case Status.CancelRequested:
      return 'var(--error-color)';
    case Status.Canceled:
      return 'var(--error-color)';
    case Status.Completed:
      return 'var(--success-color)';
    case Status.Expired:
      return 'var(--light-blue-color)';
    case Status.Partial:
      return 'var(--yellow-color)';
    case Status.Pending:
      return 'var(--light-gray-text-color)';
    case Status.Rejected:
      return 'var(--rejected-color)';
  }
};
